import { HttpClient } from '@angular/common/http';
import {TranslateModule , TranslateLoader} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../../../../environments/environment';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.language, '.json');
}


export const translateModule = TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [HttpClient],
    }
  });

  
  


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/translate/translate.ts